export { EducationCard } from './EducationCard';
export type { EducationCardProps, Education } from './EducationCard';

